(function () {
  function getSection(element) {
    return element && element.closest('.shopify-section');
  }

  function getModalChart(card) {
    var section = getSection(card);
    return section ? section.querySelector('[data-product-size-guide-image]') : document.querySelector('[data-product-size-guide-image]');
  }

  function injectDesktopChart(card) {
    if (!card || card.querySelector('[data-pdp-size-chart-image], [data-approved-size-chart]')) return;

    var source = getModalChart(card);
    if (!source) return;

    var inchesSrc = source.getAttribute('data-inches-src') || source.src;
    var cmSrc = source.getAttribute('data-cm-src') || source.src;
    var initialSrc = inchesSrc || cmSrc;
    if (!initialSrc) return;

    var figure = document.createElement('figure');
    figure.className = 'self-figma-pdp__desktop-size-chart-figure';
    figure.setAttribute('data-pdp-size-chart-figure', '');

    var image = document.createElement('img');
    image.src = initialSrc;
    image.alt = source.alt || 'Product size chart';
    image.loading = 'lazy';
    image.setAttribute('data-pdp-size-chart-image', '');
    image.setAttribute('data-inches-src', inchesSrc || '');
    image.setAttribute('data-cm-src', cmSrc || '');

    figure.appendChild(image);

    var table = card.querySelector('[data-pdp-size-chart]');
    if (table) {
      table.insertAdjacentElement('beforebegin', figure);
    } else {
      card.appendChild(figure);
    }
  }

  function initDesktopCharts(root) {
    (root || document).querySelectorAll('.self-figma-pdp__size-chart-card').forEach(injectDesktopChart);
  }

  function syncUnitToggle(toggle, activeButton) {
    toggle.querySelectorAll('[data-pdp-size-unit]').forEach(function (button) {
      var active = button === activeButton;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pdp-size-unit]');
    if (!button) return;

    var toggle = button.closest('[role="tablist"]');
    if (!toggle) return;

    syncUnitToggle(toggle, button);
    var card = toggle.closest('.self-figma-pdp__size-chart-card');
    var table = card?.querySelector('[data-pdp-size-chart]');
    if (table) table.dataset.unit = button.dataset.pdpSizeUnit;

    var image = card?.querySelector('[data-pdp-size-chart-image]');
    if (image) {
      var nextSrc = button.dataset.pdpSizeUnit === 'cm' ? image.getAttribute('data-cm-src') : image.getAttribute('data-inches-src');
      if (nextSrc) image.src = nextSrc;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDesktopCharts(document);
    });
  } else {
    initDesktopCharts(document);
  }
})();
